/** Guide tab: how the library is used in the field and how to keep it trustworthy. */
export function EquipmentGuide() {
  return (
    <div className="max-w-3xl space-y-6 text-sm leading-relaxed">
      <section className="space-y-2">
        <h3 className="text-base font-semibold">What this library is for</h3>
        <p>
          Before linking a sensor in an installation job, the technician photographs the unit&apos;s serial plate in the
          technician portal. The portal reads the brand and model and, when it finds the model here, shows where ATEK installs
          on it: the cable port, the probe and sensor positions, photos of past ATEK installs, and the manufacturer documents.
        </p>
      </section>
      <section className="space-y-2">
        <h3 className="text-base font-semibold">Verified means checked on a real unit</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Verified</strong>: confirmed on an installed unit or in the manufacturer drawing.</li>
          <li><strong>Face verified</strong> / <strong>Face + height verified</strong>: only that part of the position is confirmed.</li>
          <li><strong>Not verified</strong>: an estimate. The portal labels it as such; never upgrade it without evidence.</li>
        </ul>
        <p>Positions are fractions of the face or cabinet: 0 is left, bottom or front; 1 is right, top or back.</p>
      </section>
      <section className="space-y-2">
        <h3 className="text-base font-semibold">Reviewing technician submissions</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Merge</strong> when the plate is a model already in the library, spelled differently. The spelling is remembered, so the next plate matches.</li>
          <li><strong>Approve as new model</strong> when it really is a new unit. Check the brand, model and type before approving.</li>
          <li><strong>Reject</strong> with a reason when the photos are not usable or the unit is not monitored.</li>
          <li>Publish only photos that show no people, customer names or serial numbers. The serial-plate photo is never published.</li>
        </ul>
      </section>
      <section className="space-y-2">
        <h3 className="text-base font-semibold">Documents</h3>
        <p>
          Manufacturer manuals are copyrighted. They are stored privately and open through links that expire after a few minutes,
          for ATEK staff here and for technicians in an installation job.
        </p>
      </section>
    </div>
  );
}
